// FloatingTooltip.jsx
import React, { useEffect, useRef } from 'react'
import { FloatingPortal } from '@floating-ui/react'

const FloatingTooltip = ({ open, coordsRef, text, children, color }) => {
  const tooltipRef = useRef(null)

  useEffect(() => {
    if (!open) return
    let animationFrame

    const updatePosition = () => {
      if (tooltipRef.current && coordsRef.current.x != null && coordsRef.current.y != null) {
        const { x, y } = coordsRef.current
        // Adjust the offset as needed
        tooltipRef.current.style.top = `${y + 20}px`
        tooltipRef.current.style.left = `${x + 20}px`
      }
      animationFrame = requestAnimationFrame(updatePosition)
    }
    animationFrame = requestAnimationFrame(updatePosition)

    return () => cancelAnimationFrame(animationFrame)
  }, [open, coordsRef])

  if (!open) return null

  const textColor = color === '#e4e4e7' ? '#000' : '#fff'

  return (
    <FloatingPortal>
      <div
        ref={tooltipRef}
        style={{
          position: 'fixed',
          color: textColor,
          backgroundColor: color,
          padding: '8px',
          borderRadius: '4px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
          pointerEvents: 'none',
          zIndex: 9999,
          // top and left will be updated dynamically
        }}
      >
        {children ? children : text}
      </div>
    </FloatingPortal>
  )
}

export default FloatingTooltip